module.exports = __webpack_public_path__ + "media/images/favicon-1e17aefbeb93d66a71936f6c002ccf04.png";